module.exports = __webpack_public_path__ + "img/date.b0a05c02.png";